/**
 * PersonLastName
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectPersonValue } from '../../services/people/selectors';

export class PersonLastName extends React.PureComponent {
    render() {
        return this.props.lastName;
    }
}

PersonLastName.propTypes = {
    lastName: PropTypes.string
};

PersonLastName.defaultProps = {
    lastName: null
};

const mapStateToProps = createStructuredSelector({
    lastName: makeSelectPersonValue('lastName')
});

export default connect(mapStateToProps)(PersonLastName);
